import _ from 'lodash';
import { modal } from '../../modal/ModalEmitter';
import toastr from '../../toastr';
import VoidRo from './VoidRo';
import PrintHardCard from './PrintHardCard';
import PaymentSaleForm from '../../payment/PaymentSaleForm';
import PaymentSessionRefundSimple from '../../payment/PaymentSessionRefundSimple';
import ApiService from '../../../services/ApiService';
import AuthService from '../../../services/AuthService';

export default function getActions(itemName, data) {
  const itemId = _.get(data, 'itemId.data');

  const actions = {
    // repair order close
    SMM6: [
      {
        label: 'Submit',
        side: 'left',
        type: 'submit',
        style: 'primary',
        action: ({ onSubmit, manager }) => {
          // if an amount for credit card is set the user will be prompted for payment
          // else submission will continue normally
          if (!AuthService.hasCardTerminalPayments()) {
            onSubmit();
            return;
          }

          let cashAmount;
          let creditAmount;
          let customerNum;
          let invoiceNum;
          for (const item of manager.exportData()) {
            if (item.name === 'SMM6__144') {
              cashAmount = item.data;
            }
            if (item.name === 'SMM6__145') {
              creditAmount = item.data;
            }
            if (item.name === 'SMM6__146') {
              invoiceNum = item.data;
            }
            if (item.name === 'SMM6__147') {
              customerNum = item.data;
            }
          }

          if (!creditAmount || parseFloat(creditAmount) <= 0) {
            // no CC money, submit as usual
            onSubmit();
            return;
          }

          if (!invoiceNum || !customerNum) {
            toastr.error('Missing RO# or Customer#');
            return;
          }

          modal.open('Payment', {
            closeButton: false,
            headerClass: 'primary',
            hideFooter: true,
            hidePrint: true,
            size: 'md',
            staticBackdrop: true,
            style: 'center',
            title: 'Credit Card Payment',
            message: (
              <PaymentSaleForm
                amount={parseFloat((parseFloat(cashAmount || 0) + parseFloat(creditAmount)).toFixed(2))}
                customerNum={customerNum}
                department="service"
                invoiceNum={invoiceNum}
                enabledHostedPayments={false}
                onCancel={response => {
                  ApiService.put(`/payment/session/${response.sessionId}/cancel`).catch(err => {
                    console.error(err);
                    toastr.error('Payment session failed to cancel.');
                  });
                }}
                onSuccess={response => {
                  const form = manager.getData();

                  // add response data to the form
                  form.payment = {
                    data: JSON.stringify(response),
                  };

                  onSubmit()
                    .then(() => {
                      ApiService.put(`/payment/session/${response.sessionId}/complete`).catch(err => {
                        console.error(err);
                        toastr.error('Payment session failed to complete.');
                      });
                    })
                    .catch(err => {
                      console.error(err);
                      toastr.error(err.message);
                    });
                }}
              />
            ),
          });
        },
      },
    ],
    SMM8: [
      {
        label: 'Submit',
        side: 'left',
        type: 'submit',
        style: 'primary',
        action: ({ onSubmit, manager }) => {
          // if an amount for credit card is set the user will be prompted for payment
          // else submission will continue normally
          if (!AuthService.hasCardTerminalPayments()) {
            onSubmit();
            return;
          }

          let creditAmount;
          let customerNum;
          let invoiceNum;
          for (const item of manager.exportData()) {
            if (item.name === 'SMM8__13') {
              creditAmount = item.data;
            }
            if (item.name === 'SMM8__10') {
              invoiceNum = item.data;
            }
            if (item.name === 'SMM8__11') {
              customerNum = item.data.split(' ')[0];
            }
          }

          if (!creditAmount || parseFloat(creditAmount) <= 0) {
            // no CC money, submit as usual
            onSubmit();
            return;
          }

          if (!invoiceNum || !customerNum) {
            toastr.error('Missing RO# or Customer#');
            return;
          }

          modal.open('Payment', {
            title: 'Credit Card Refund',
            hidePrint: true,
            hideFooter: true,
            style: 'center',
            staticBackdrop: true,
            size: 'md',
            headerClass: 'primary',
            message: (
              <PaymentSessionRefundSimple
                amount={parseFloat(parseFloat(creditAmount).toFixed(2))}
                customerNum={customerNum}
                invoiceNum={invoiceNum}
                onSuccess={response => {
                  const form = manager.getData();

                  // add response data to the form
                  form.payment = {
                    data: JSON.stringify(response),
                  };

                  onSubmit();
                }}
              />
            ),
          });
        },
      },
    ],
    APA1B: [
      {
        label: 'Pay',
        style: 'success',
        side: 'left',
        type: 'submit',
        action: ({ onSubmit, manager }) => {
          let amount;
          const invoiceData = {};
          for (const item of manager.exportData()) {
            if (item.name === 'S.TABLE_APA1B_102') {
              // Credit Amount To Pay
              amount = item.data;
              continue;
            }

            if (item.name === 'S.TABLE_APA1B_14') {
              // Invoice number
              invoiceData.number = item.data;
              continue;
            }

            if (item.name === 'S.TABLE_APA1B_18') {
              // Invoice amount
              invoiceData.amount = item.data;
              continue;
            }

            if (item.name === 'S.TABLE_APA1B_19') {
              // Invoice checkbox
              invoiceData.selected = item.data;
              continue;
            }
            if (item.name === 'S.TABLE_APA1B_21') {
              // additional Invoice number
              invoiceData.additionalNumber = item.data;
              continue;
            }

            if (item.name === 'S.TABLE_APA1B_22') {
              // additional Invoice amount
              invoiceData.additionalAmount = item.data;
              continue;
            }
          }

          const invoices = [];
          for (let i = 0; i < invoiceData.selected.length; i++) {
            if (invoiceData.selected[i] === 'Y') {
              invoices.push({
                invoiceNum: invoiceData.number[i],
                amount: parseFloat(invoiceData.amount[i]),
              });
            }
          }

          if (invoiceData.additionalNumber) {
            for (let i = 0; i < invoiceData.additionalNumber.length; i++) {
              invoices.push({
                invoiceNum: invoiceData.additionalNumber[i],
                amount: -1 * parseFloat(invoiceData.additionalAmount[i]),
              });
            }
          }

          if (parseFloat(amount) <= 0) {
            toastr.error('Amount must be positive');
            return;
          }

          const handleSubmit = response => {
            const form = manager.getData();

            // add response data to the form
            form.payment = {
              // TODO talk about adding just response token
              data: JSON.stringify(response),
            };

            onSubmit().then(() => {
              ApiService.put(`/payment/session/${response.sessionId}/complete`).catch(err => {
                console.error(err);
                toastr.error('Failed to complete payment session');
              });

              modal.close();
            });
          };

          modal.open('Payment', {
            closeButton: false,
            headerClass: 'primary',
            hideFooter: true,
            hidePrint: true,
            size: 'md',
            staticBackdrop: true,
            style: 'center',
            title: 'Credit Card Payment',
            message: (
              <PaymentSaleForm
                customerNum={itemId}
                department="accounting"
                enabledHostedPayments
                onSuccess={handleSubmit}
                amount={parseFloat(amount)}
                invoices={invoices}
                openOnly
                noCash
              />
            ),
          });
        },
      },
    ],
    SMM6D: [
      {
        label: 'Pay',
        style: 'success',
        side: 'left',
        type: 'submit',
        action: ({ onSubmit, manager }) => {
          let amount;
          let customerNum;
          const invoiceData = {};
          for (const item of manager.exportData()) {
            if (item.name === 'amount__1') {
              // Credit Amount To Pay
              amount = item.data;
              invoiceData.amount = item.data;
              continue;
            }

            if (item.name === 'repairOrder__2') {
              // Invoice number
              invoiceData.number = item.data;
              continue;
            }

            if (item.name === 'SMM6D__3') {
              customerNum = item.data;
              continue;
            }
          }

          const invoices = [];
          invoices.push({
            invoiceNum: invoiceData.number,
            amount: parseFloat(invoiceData.amount),
            deposit: true,
          });

          if (parseFloat(amount) <= 0) {
            toastr.error('Amount must be positive');
            return;
          }

          const handleSubmit = response => {
            const form = manager.getData();

            // Add per Gail
            response.origin = 'SMM6D';

            // add response data to the form
            form.payment = {
              // TODO talk about adding just response token
              data: JSON.stringify(response),
            };

            onSubmit().then(() => {
              ApiService.put(`/payment/session/${response.sessionId}/complete`).catch(err => {
                console.error(err);
                toastr.error('Failed to complete payment session');
              });

              modal.close();
            });
          };

          modal.open('Payment', {
            closeButton: false,
            headerClass: 'primary',
            hideFooter: true,
            hidePrint: true,
            size: 'md',
            staticBackdrop: true,
            style: 'center',
            title: 'Credit Card Payment',
            message: (
              <PaymentSaleForm
                customerNum={customerNum}
                department="service"
                enabledHostedPayments={false}
                onSuccess={handleSubmit}
                amount={parseFloat(amount)}
                invoices={invoices}
                openOnly
                noCash
              />
            ),
          });
        },
      },
    ],
    SMM1: [
      {
        label: 'Save & Print',
        style: 'primary',
        side: 'left',
        type: 'submit',
        action: ({ onSubmit }) => {
          onSubmit().then(({ submitted, response }) => {
            let useItemId = itemId;
            // Newly recreated, grab it from response
            if (!itemId || itemId === 'New') {
              useItemId = _.get(response, 'response.data.responses[0].itemid');
            }

            if (submitted) {
              modal.open('PrintHardCard', {
                title: `Print Hard Card ${useItemId}`,
                style: 'center',
                size: 'md',
                hidePrint: true,
                hideFooter: true,
                staticBackdrop: true,
                message: <PrintHardCard roId={useItemId} />,
              });
            }
          });
        },
      },
      {
        label: 'Void',
        style: 'danger',
        side: 'right',
        action: () => {
          modal.open('VoidRO', {
            title: `Void RO ${itemId}`,
            style: 'center',
            size: 'md',
            hidePrint: true,
            hideFooter: true,
            message: <VoidRo roId={itemId} />,
          });
        },
      },
    ],
  };

  // Actions that don't apply to 'Create New'
  if (!itemId) {
    delete actions.EQS1;
  }

  return actions[itemName] || [];
}
